export default {
  name: 'pc-editor',
  props: {
    widgets: {
      type: Object,
      default: function _default() {
        return {
          title: '富文本',
          icon: 'el-icon-edit',
          content: {
            html: ''
          },
          config: [{
            label: '富文本内容',
            name: 'html',
            type: 'editor',
            value: ''
          }]
        };
      }
    }
  },
  data: function data() {
    return {};
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {},
  methods: {}
};